import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';
import { hasSessionToken, isSessionExpired } from './auth-session-utils';

export const authSessionGuard: CanActivateFn = (route, state) => {

  const _router = inject(Router);
  const _auth = inject(Auth);

  _auth.setRedirectUrl(state.url);

  if (!hasSessionToken()) {

    return _router.createUrlTree(['login']);
  }

  if (isSessionExpired()) {

    _auth.setSessionExpired();
    _auth.clearAuthStorage();

    return _router.createUrlTree(['login']);
  }

  return true;
};